export default function reportsReducer(state = {
  filterParams: {
    rdr_codes: [],
    abm_codes: [],
    rbm_codes: [],
    levels: [],
    outlet_codes: [],
    groups: [],
    brand_id: null,
    dateFrom: '',
    dateTo: ''
  },
  fetching: false,
  fetched: false,
  errors: {},
  reportData: {}
}, action) {
  switch (action.type) {
    case 'GET_REPORTS_FILTER_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_REPORTS_FILTER_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        filterParams: action.payload,
      };
    }
    case 'GET_REPORTS_FILTER_REJECTED': {
      return state;
    }
    case 'GET_REPORT_TILES_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_REPORT_TILES_FULFILLED': {
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        reportData: Object.assign({}, state.reportData, {[action.key]: action.payload})
      });
    }
    case 'GET_REPORT_TILES_REJECTED': {
      return state;
    }
    default:
      return {...state};
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reportsReducer.js